/* eslint-disable */ 
import React from 'react' ;
import { Panel as PanelImp} from 'primereact/panel';


export default function Panel (props) {

    return <PanelImp {...props} />
    
}